/*
 * @Description:
 * @Version: 2.0
 * @Author: liangdengke
 * @Date: 2022-07-14 17:26:44
 * @LastEditors: liangdengke
 * @LastEditTime: 2022-07-18 17:01:33
 */
import { loginFn, loginUserFn, currencyTypeFn, logoutFn, registerFn } from "@/serves/user";
import { $delAllCookie, $setCookie } from "@/utils/utils";
export default {
  namespaced: true,
  state: {
    userInfo: {}
  },
  mutations: {
    userInfo: (state, userInfo) => {
      Object.assign(state.userInfo, userInfo);
    },
  },
  getters: {
    userInfo: state => state.userInfo
  },
  actions: {
    // 登录
    LoginUser({ }, params) {
      return new Promise((resolve, reject) => {
        loginUserFn(params).then(data => {
          resolve(data);
        }).catch(err => {
          reject(err);
        });
      });
    },

    // 获取用户登录信息
    async Login({ commit, dispatch }, params) {
      return new Promise((resolve, reject) => {
        loginFn(params).then(async res => {
          // commit(TOKEN, data.token, { root: true });
          commit("userInfo", res.data.user);
          $setCookie("token", res.data.token);
          await dispatch("CurrencyType");
          resolve();
        }).catch(err => {
          reject(err);
        });
      });
    },
    // 获取用户登录信息
    async register(state, params) {
      return new Promise((resolve, reject) => {
        registerFn(params).then(async () => {
          // commit(TOKEN, data.token, { root: true });
          // commit("userInfo", data);
          // $setCookie("token", data.token);
          // await dispatch("CurrencyType");
          resolve();
        }).catch(err => {
          reject(err);
        });
      });
    },
    // 获取通用类数据
    async CurrencyType({ commit }) {
      return new Promise((resolve, reject) => {
        currencyTypeFn().then(data => {
          commit("commonData", data.data, { root: true });
          resolve();
        }).catch(err => {
          reject(err);
        });
      });
    },

    // 退出登录
    async Logout({ commit }) {
      return new Promise((resolve, reject) => {
        logoutFn().then(() => {
          // commit(TOKEN, '', { root: true });
          commit("userInfo", {});
          $delAllCookie();
          resolve();
          // 退出时如果地址中存在token,则将其删除，防止造成的页面频繁刷新的问题
          let hrefList = window.location.href.split("token=");
          // 存在token，则删除token
          if (hrefList[1]) {
            window.location.href = hrefList[0] + hrefList[1].slice(33);
          } else {
            // 不存在token，则刷新页面
            window.location.reload();
          }
        }).catch(err => {
          reject(err);
        });
      });
    },
  }
};
